import { render, staticRenderFns } from "./Bubble4.vue?vue&type=template&id=52181e36"
import script from "./Bubble4.vue?vue&type=script&lang=js"
export * from "./Bubble4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports